import { gql } from '@apollo/client';

export const INTERIOR_COLORS = gql`
  query getAvailableInteriorColors($inputInteriorColor: String!) {
    getAvailableInteriorColors(inputInteriorColor: $inputInteriorColor)
  }
`;
